import React from 'react';
import cn from 'classnames';

import DynamicIconWrapper from '@components/common/DynamicIconWrapper';
import { THandleChange } from '@components/common/Select/Select';
import Tooltip from '@components/common/Tooltip';

import { Icons } from '@icons/icons';

import { TSelectOptionType } from '@components/common/Select/Select.types';

import colors from '@constants/colors';

interface IItemActionsIconsProps {
	isFocused: boolean;
	isSelected: boolean;
	isEditable: boolean;
	isRenamable: boolean;
	data: TSelectOptionType;
	resetFocus: () => void;
	onEditClick?: THandleChange;
	onRenameClick?: THandleChange;
	onDeleteClick?: THandleChange;
	handleEdit: () => void;
	handleRename: () => void;
	handleDelete: () => void;
	editTooltip?: string;
	renameTooltip?: string;
	deleteTooltip?: string;
}

const ItemActionsIcons = ({
	isFocused,
	isSelected,
	isEditable,
	isRenamable,
	data,
	resetFocus,
	onEditClick,
	onRenameClick,
	onDeleteClick,
	handleEdit,
	handleRename,
	handleDelete,
	editTooltip,
	renameTooltip,
	deleteTooltip,
}: IItemActionsIconsProps) => {

	return (
		<div
			className={cn('f5gEditableSelectEditButtons', {
				focused: isFocused,
				selected: isSelected,
				topOffset: !!data?.subText,
			})}
			onMouseEnter={resetFocus}
		>
			{isEditable && onEditClick && (
				<Tooltip
					content={editTooltip}
					isDisabled={!editTooltip}
				>
					<div onClick={handleEdit}>
						{isSelected
							? Icons.createIcon({ color: colors.white })
							: <DynamicIconWrapper icon={Icons.createIcon}/>
						}
					</div>
				</Tooltip>
			)}
			{isRenamable && onRenameClick && (
				<Tooltip
					content={renameTooltip}
					isDisabled={!renameTooltip}
				>
					<div onClick={handleRename}>
						{isSelected
							? Icons.editCustomColor({ color: colors.white })
							: <DynamicIconWrapper icon={Icons.editCustomColor}/>
						}
					</div>
				</Tooltip>
			)}
			{onDeleteClick && (
				<Tooltip content={deleteTooltip}>
					<div onClick={handleDelete}>
						{isSelected
							? Icons.deleteCustomColor({ color: colors.white })
							: <DynamicIconWrapper icon={Icons.deleteCustomColor}/>
						}
					</div>
				</Tooltip>
			)}
		</div>
	);
};

export default ItemActionsIcons;
